<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-input v-model="page.repositoryName" class="ipt-sty w70f" placeholder="请输入算法名称"></el-input
        ></el-col>
        <el-col :span="5">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <!-- <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加算法计算</el-button> -->
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="mathConditionName" label="计算结果名称" header-align="center" align="left" show-overflow-tooltip></el-table-column>  -->
        <el-table-column prop="repositoryName" label="算法名称" header-align="center" align="center" show-overflow-tooltip></el-table-column> 
        <el-table-column prop="createTime" label="操作时间" sortable header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <!-- <el-table-column prop="createUserName" label="操作人" header-align="center" align="center"></el-table-column>  -->
        <!-- <el-table-column prop="conditionValue" label="条件设置"  show-overflow-tooltip header-align="center" align="center"> -->
          <!-- <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template> -->
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="getMathRepositoryDataLink(scope.row)">查看 | </a>
            <!-- <a class="txt-color" @click="add(2, scope.row)">编辑 | </a> -->
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
      <el-form-item label="计算结果名称" prop="mathConditionName">
        <el-input v-model="ruleForm.mathConditionName"></el-input>
      </el-form-item>
        <el-form-item label="算法名称:" prop="mathRepositoryGuid ">
          <el-select v-model="ruleForm.mathRepositoryGuid" placeholder="算法名称" class="w100f" @change="selectChange">
            <el-option :label="ma.repositoryName" :value="ma.guid" :key="ma.guid" v-for="ma in mathRepositoryData"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
        <el-input type="textarea" v-model="ruleForm.remark"></el-input>
        </el-form-item>
        <div style="border-bottom: 1px solid #eeeeee;text-align: left;font-weight: bold;margin-left: 28px;margin-bottom: 15px;width: 480px;height: 30px;">条件设置</div>
        <div v-if="repositoryTypeGuid == 'e4a9ff9aa3fc11ebb4bb080027ac9e40'">
        <el-form-item label="预测年度:">
          <el-date-picker
              v-model="timeListS"
              type="monthrange"
              class="w100f"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
        </el-date-picker>
        </el-form-item>
        </div>
        <div v-if="repositoryTypeGuid == '7b83e625a6fd11ebb4bb080027ac9e40'">
        <el-form-item label="销售区间:">
          <el-date-picker
              v-model="year"
              type="year"
              class="w100f"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份">
        </el-date-picker>
        </el-form-item>
        </div>
        <div v-if="repositoryTypeGuid == 'e4a9faefa3fc11ebb4bb080027ac9e40'">
              <el-form-item label="现有/原有成本:">
                <el-select v-model="newOldCostRate" placeholder="请选择" class="w100f">
                  <el-option
                    v-for="item in costList"
                    :key="item.value" 
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销量排名:">
                <el-select v-model="yearSalesRanking" placeholder="请选择" class="w100f">
                  <el-option v-for="item in rankingList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="测算年度:">
                <el-date-picker
                  v-model="year1"
                  type="year"
                  class="w100f"
                  placeholder="选择年">
                </el-date-picker>
              </el-form-item>
        </div>
      </el-form> 
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '添加算法计算'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      timeListS:'',
      year:'',
      newOldCostRate:'',
      yearSalesRanking:'',
      year1:'',
      ruleForm: {
        mathConditionName: '',  
        mathRepositoryGuid:'',
        remark:'',
      },
      rankingList:[{
          value: '1',
          label: '前1名'
        },{
          value: '2',
          label: '前2名'
        }, {
          value: '3',
          label: '前3名'
        }, {
          value: '4',
          label: '前4名'
        }, {
          value: '5',
          label: '前5名'
        },{
          value: '6',
          label: '前6名'
        }, {
          value: '7',
          label: '前7名'
        }, {
          value: '8',
          label: '前8名'
        }, {
          value: '9',
          label: '前9名'
        }, {
          value: '10',
          label: '前10名'
        }],
      costList:[{
          value: '2',
          label: '小于2'
        }, {
          value: '3',
          label: '小于3'
        }, {
          value: '4',
          label: '小于4'
        }],
      conditionValues:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        repositoryName: '', 
      },
      repositoryName:'',
      repositoryTypeGuid:'',
      mathRepositoryData:[],
      tableData: [],
      rules: {
        mathConditionName: [
          { required: true, message: '请输入岗位', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
      },
      multipleSelection: [],
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getMathRepositoryData();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        repositoryName: '', 
      };
      self.getData(true);
    },
    getMathRepositoryData() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`,{'pageIndex':'1','pageSize':-1}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.mathRepositoryData = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      } 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-condition/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('当前岗位有用户使用，是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/math-condition/data/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除算法计算成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    }, 
    getMathRepositoryDataLink(row) {
      let self = this;  
      let repositoryDescription  = '';
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`,{'repositoryName':row.repositoryName}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records != null){
              repositoryDescription = res.data.data.records[0].repositoryDescription;
          }
          if(row.repositoryTypeGuid == '1'){  
                  this.$router.push({path: "/algorithmResultQuery", query:{ productGuid:this.$route.query.productGuid,list:row.conditionValue,guid:row.guid,repositoryDescription:JSON.stringify(repositoryDescription)}}); 
            }else if(row.repositoryTypeGuid == '3'){
                  this.$router.push({path: "/salesForecastAnalysis", query:{ productGuid:this.$route.query.productGuid,list:row.conditionValue,guid:row.guid,repositoryDescription:JSON.stringify(repositoryDescription)}}); 
            }else if(row.repositoryTypeGuid == '2'){
                  this.$router.push({path: "/commodityClassificationAnalysis", query:{ productGuid:this.$route.query.productGuid,list:row.conditionValue,guid:row.guid,repositoryDescription:JSON.stringify(repositoryDescription)}}); 
            }
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加算法计算';
        self.timeListS = '';
        self.year = '';
        self.conditionValues = [];
        self.repositoryName = '';
        self.year1 = '';
        self.newOldCostRate = '';
        self.yearSalesRanking = '';
        self.ruleForm.mathConditionName = '';
        self.ruleForm.mathRepositoryGuid = '';
        self.ruleForm.remark = ''; 
      } else {
        self.textTitle = '编辑算法计算';
        self.ruleForm.guid = row.guid;
        let list = '';
         if(row.conditionValue != null){
              list = JSON.parse(row.conditionValue); 
              console.log(list);
        } 
        self.timeListS = [list[0].startMonth,list[0].endMonth];
        self.year = list[0].year;
        self.conditionValues = [];
        self.repositoryName = row.repositoryName;
        self.year1 = list[0].year;
        self.newOldCostRate = list[0].newOldCostRate;
        self.yearSalesRanking = list[0].yearSalesRanking;
        self.ruleForm.mathConditionName = row.mathConditionName;
        self.ruleForm.mathRepositoryGuid = row.mathRepositoryGuid;
        self.ruleForm.remark = row.remark;  
      }
      this.dialogFormVisible = true;
    },
    selectChange(val){ 
      let self = this; 
        self.timeListS = '';
        self.conditionValues = [];
        self.repositoryName = '';
        self.repositoryTypeGuid = '';
        self.year = '';
        self.year1 = '';
        self.newOldCostRate = '';
        self.yearSalesRanking = '';
        if(self.mathRepositoryData != null){
            self.mathRepositoryData.forEach(function(i){
                  if(val == i.guid){
                        self.repositoryName = i.repositoryName;
                        self.repositoryTypeGuid = i.repositoryType;
                  }
            })
        }
    },
    submitForm(formName) {
      let self = this;
      self.conditionValues = [];
      if(self.repositoryTypeGuid == 'e4a9ff9aa3fc11ebb4bb080027ac9e40'){
            if(self.timeListS !=''){
                  let item = {
                       startMonth:self.$moment(self.timeListS[0]).format('YYYY-MM'),
                       endMonth:self.$moment(self.timeListS[1]).format('YYYY-MM'),
                  }
                  self.conditionValues.push(item);
            }
      }
      if(self.repositoryTypeGuid == '7b83e625a6fd11ebb4bb080027ac9e40'){
            if(self.year != ''){
                  let item = {
                       year:self.$moment(self.year).format('YYYY')
                  }
                  self.conditionValues.push(item);
            } 
      }
      if(self.repositoryTypeGuid == 'e4a9faefa3fc11ebb4bb080027ac9e40'){
            let year = '';
            if(self.year1 != ''){
                    year = self.$moment(self.year1).format('YYYY');
            }
            let item = {
                       year:year,
                       newOldCostRate:self.newOldCostRate,
                       yearSalesRanking:self.yearSalesRanking
                  }
            if(self.newOldCostRate !='' || self.year1 != '' || self.yearSalesRanking != ''){
                  self.conditionValues.push(item);
            } 
      }
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            mathConditionName:self.ruleForm.mathConditionName,
            mathRepositoryGuid: self.ruleForm.mathRepositoryGuid,
            repositoryName: self.repositoryName,
            remark:self.ruleForm.remark,
            repositoryTypeGuid:self.repositoryTypeGuid,
            conditionValues: self.conditionValues, 
          };
          self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-condition/data/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加算法计算成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
       self.conditionValues = [];
       if(self.repositoryTypeGuid == 'e4a9ff9aa3fc11ebb4bb080027ac9e40'){
            if(self.timeListS !=''){
                  let item = {
                       startMonth:self.$moment(self.timeListS[0]).format('YYYY-MM'),
                       endMonth:self.$moment(self.timeListS[1]).format('YYYY-MM'),
                  }
                  self.conditionValues.push(item);
            }
      }
      if(self.repositoryTypeGuid == '7b83e625a6fd11ebb4bb080027ac9e40'){
            if(self.year != ''){
                  let item = {
                       year:self.$moment(self.year).format('YYYY')
                  }
                  self.conditionValues.push(item);
            } 
      }
      if(self.repositoryTypeGuid == 'e4a9faefa3fc11ebb4bb080027ac9e40'){
            let year = '';
            if(self.year1 != ''){
                    year = self.$moment(self.year1).format('YYYY');
            }
            let item = {
                       year:year,
                       newOldCostRate:self.newOldCostRate,
                       yearSalesRanking:self.yearSalesRanking
                  }
            if(self.newOldCostRate !='' || self.year1 != '' || self.yearSalesRanking != ''){
                  self.conditionValues.push(item);
            } 
      }
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            mathConditionName:self.ruleForm.mathConditionName,
            mathRepositoryGuid: self.ruleForm.mathRepositoryGuid,
            repositoryName: self.repositoryName,
            repositoryTypeGuid:self.repositoryTypeGuid,
            remark:self.ruleForm.remark,
            conditionValues: self.conditionValues, 
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/math-condition/data/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑算法计算成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
